import { BlankLayout } from '@/components/layouts';

export default {
  path: '/course',
  name: 'Course',
  component: BlankLayout,
  meta: { module: '课程' },
  children: [
    {
      path: '/course/main',
      name: 'Course.Main',
      component: () => import(/* webpackChunkName: 'course-main' */ '@/views/course/Main.vue'),
      meta: { title: '全部课程', hideBanner: true },
    },
    {
      path: '/course/main/search',
      name: 'Course.Main.Search',
      component: () => import(/* webpackChunkName: 'course-main-search' */ '@/views/course/MainSearch.vue'),
      meta: { title: '全部课程-搜索', hideBanner: true },
    },
    {
      path: '/course/my',
      name: 'Course.MyCourse',
      component: () => import(/* webpackChunkName: 'course-my-course' */ '@/views/course/MyCourse.vue'),
      meta: { title: '我的课程', requiredLogin: true, hideBanner: true },
    },
    {
      path: '/course/my/search',
      name: 'Course.MyCourse.Search',
      component: () => import(/* webpackChunkName: 'course-my-course-search' */ '@/views/course/MyCourseSearch.vue'),
      meta: { title: '我的课程-搜索', requiredLogin: true, hideBanner: true },
    },
    {
      path: '/course/:id',
      alias: '/course/free/:id',
      name: 'Course.Details',
      component: () => import(/* webpackChunkName: 'course-free-details' */ '@/views/course/FreeDetails.vue'),
      meta: { title: '课程详情' },
    },
    {
      path: '/course/newLive/:id',
      alias: '/course/newLive/:id',
      name: 'Course.NewLive',
      component: () => import(/* webpackChunkName: 'course-new-video' */ '@/views/course/NewLive.vue'),
      meta: { title: '新直播课程详情' },
    },
    {
      path: '/course/column/:id',
      name: 'Course.Column.Details',
      component: () => import(/* webpackChunkName: 'course-column-details' */ '@/views/course/ColumnDetails'),
      meta: { title: '课程专栏详情' },
    },
    {
      path: '/course/live/:id',
      name: 'Course.Live.Details',
      component: () => import(/* webpackChunkName: 'course-live-details' */ '@/views/course/LiveDetails'),
      meta: { title: '免费直播回看_站内', titleAlias: '直播回看详情' },
    },
    {
      path: '/course/baike/:id',
      name: 'Course.Baike.Details',
      component: () => import(/* webpackChunkName: 'course-baike-details' */ '@/views/course/BaikeDetails.vue'),
      meta: { title: '行业百科详情' },
    },
    {
      path: '/course/graphic-tutorial/:id',
      name: 'Course.GraphicTutorial.Details',
      component: () => import(/* webpackChunkName: 'course-graphic-tutorial-details' */ '@/views/course/GraphicTutorialDetails.vue'),
      meta: { title: '图文教程详情' },
    },

    {
      path: '/course/order/:id',
      name: 'Course.Order',
      component: () => import(/* webpackChunkName: 'course-order' */ '@/views/course/Order.vue'),
      meta: { title: '课程下单', requiredLogin: true, hideBanner: true },
    },
    {
      path: '/course/pay-result/:id',
      name: 'Course.Pay.Result',
      component: () => import(/* webpackChunkName: 'course-pay-result' */ '@/views/course/PayResult.vue'),
      meta: { title: '支付成功', requiredLogin: true, hideBanner: true },
    },
  ],
};
